var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonHugeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#676577"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5604 17.6279H20.4387C16.9229 17.6279 14.6945 21.4204 16.4633 24.4863L28.2645 44.9411C29.0346 46.2767 30.9645 46.2767 31.7346 44.9411L43.5382 24.4863C45.3046 21.4253 43.0762 17.6279 39.5628 17.6279H39.5604ZM28.2549 38.807L25.6848 33.8329L19.4834 22.7416C19.0743 22.0317 19.5796 21.122 20.4363 21.122H28.2525V38.8094L28.2549 38.807ZM40.5109 22.7392L34.3119 33.8353L31.7418 38.807V21.1196H39.558C40.4147 21.1196 40.92 22.0293 40.5109 22.7392Z",
    fill: "#24232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonHugeBlack);
export default __webpack_public_path__ + "static/media/ton_huge_black.6537ed8a9b11de3b37359a1963a71f0a.svg";
export { ForwardRef as ReactComponent };